import { UiTrackingDetails } from '@parship/psg-interfaces';

export class UiEvent {
	public static getCategory(): string {
		switch (document.body.id) {
			case 'homepage':
				return 'homepage';
			case 'landing-page':
				return 'landing-page';
			case 'corporate_website':
				return 'corporate_website';
			default:
				return 'editorial';
		}
	}

	public static trackUIEvent(
		subcategory: string,
		targetId: string,
		action: string,
		cd1: string = '',
		cd2: string = '',
		cd3: string = ''
	): void {
		const detail: UiTrackingDetails = {
			category: UiEvent.getCategory(),
			subcategory,
			targetId,
			action,
			cd1,
			cd2,
			cd3,
		};

		document.dispatchEvent(new CustomEvent('pegLogger-logWpEvents', { detail }));
	}
}
